"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _Rules_1 = require("./_Rules");
exports._LifecycleConfiguration = {
    type: "structure",
    required: ["Rules"],
    members: {
        Rules: {
            shape: _Rules_1._Rules,
            locationName: "Rule"
        }
    }
};
//# sourceMappingURL=_LifecycleConfiguration.js.map